import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { ToastContainer, toast } from "react-toastify";
import CountUp from "react-countup";
import { connect } from "react-redux";
import { DollarSign } from "react-feather";
import {
  getAllCategoriesRedux,
  uploadCategoryRedux,
  updateCategoryRedux,
  deleteCategoryRedux,
  getAllHomeScreenCategoriesRedux,
} from "../../../actions";
import {
  uploadImage,
  updateImage,
  deleteImage,
} from "../../../firebase/firebase.utils";
import man from "./plus image.jpeg";
import { Search } from "react-feather";
import { ClipLoader } from "react-spinners";
export class Categories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      name: "",
      slug: "",
      parentCategory: "",
      productObj: null,
      loading: false,
      loading2: false,
      imageUrl: man,
      imageUrl2: man,
      file: "",
      file2: "",
      checkedValues: [],
      selectAll: false,
      searchFor: "",
      topCategory: false,
      homePage: false,
      homePosition: "",
      homePosition2: "",
      loader: false,
      count: 0,
    };
  }

  componentDidMount = async () => {
    this.props.getAllCategoriesRedux();
    this.props.getAllHomeScreenCategoriesRedux();
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  _handleImgChange = (e, i) => {
    e.preventDefault();

    const fileInput = e.target; // 🧠 store a reference before async code
    const file = fileInput.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        file: file,
        imageUrl: reader.result, // base64 preview
      });

      // 🛠️ Reset input safely
      if (fileInput) fileInput.value = "";
    };

    reader.onerror = (err) => {
      console.error("File reading error:", err);
    };

    reader.readAsDataURL(file);
  };
  _handleImgChange2 = (e, i) => {
    e.preventDefault();

    const fileInput = e.target; // 🧠 store a reference before async code
    const file = fileInput.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        file2: file,
        imageUrl2: reader.result, // base64 preview
      });

      // 🛠️ Reset input safely
      if (fileInput) fileInput.value = "";
    };

    reader.onerror = (err) => {
      console.error("File reading error:", err);
    };

    reader.readAsDataURL(file);
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  handleSubmit = async () => {
    const {
      type,
      file,
      file2,
      name,
      visible,
      categoryId,
      expiryDate,
      productObj,
      id,
      count,
      parentCategory,
      topCategory,
      homePage,
      homePosition,
      homePosition2,
      slug,
    } = this.state;
    let date = new Date();
    const isUpdate = type === "update";
    const isUpload = type === "upload";

    if (isUpload && !file) {
      return toast.error("Please upload campaign image");
    }
    const { homeCategories } = this.props;

    if (this.state.homePage && this.state.homePosition == "") {
      alert("You must select a home screen postion for this category");
      return;
    }

    // Build upload/update functions based on availability of file(s)
    const uploadMainImage = file
      ? isUpdate
        ? () => updateImage(file, productObj.logo, "categories")
        : () => uploadImage(file, "categories")
      : () => Promise.resolve(productObj?.logo || "");

    const uploadBannerImage = file2
      ? isUpdate
        ? () => updateImage(file2, productObj.banner, "categories")
        : () => uploadImage(file2, "categories")
      : () => Promise.resolve(productObj?.banner || "");
    try {
      const [imgUrl, imgUrl2] = await Promise.all([
        uploadMainImage(),
        uploadBannerImage(),
      ]);

      if (isUpload && !imgUrl) return toast.error("Image upload failed");

      let categoryObj = {
        id: isUpdate ? id : date.getTime().toString(),
        name,
        slug,
        count,
        parentCategory,
        logo: imgUrl,
        banner: imgUrl2,
        topCategory: topCategory ? topCategory : false,
        homePage: homePage ? homePage : false,
        homePosition: homePosition ? homePosition : false,
      };

      isUpdate
        ? await this.props.updateCategoryRedux(
            categoryObj,
            homeCategories.length
          )
        : await this.props.uploadCategoryRedux(
            categoryObj,
            homeCategories.length
          );
    } catch (err) {
      console.error("Error uploading campaign:", err);
      toast.error("Something went wrong");
    }
    this.setState({
      id: "",
      name: "",
      slug: "",
      parentCategory: "",
      productObj: null,
      loading: false,
      loading2: false,
      imageUrl: man,
      imageUrl2: man,
      file: "",
      file2: "",
      checkedValues: [],
      selectAll: false,
      homePage: false,
      homePosition: "",
      count: 0,
    });
  };
  handleChangeCustomer = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, showSuggestion: true, cursor: -1 });
  };
  handleKeyDown = (e) => {
    const { cursor } = this.state;
    let result = [];
    if (this.state.customer) {
      const suggestionById = this.props.allUsers.filter((user) =>
        user.userId.includes(this.state.customer)
      );
      const suggestionByName = this.props.allUsers.filter(
        (user) =>
          user.displayName &&
          user.displayName
            .toLowerCase()
            .includes(this.state.customer.toLowerCase())
      );
      result = [...suggestionById, ...suggestionByName].slice(0, 10);

      // arrow up/down button should select next/previous list element
      if (e.keyCode === 38 && cursor > -1) {
        this.setState((prevState) => ({
          cursor: prevState.cursor - 1,
        }));
      } else if (e.keyCode === 40 && cursor < result.length - 1) {
        this.setState((prevState) => ({
          cursor: prevState.cursor + 1,
        }));
      } else if (e.keyCode === 13 && cursor > -1) {
        this.setState({
          customer: result[cursor].userId,
          customerUid: result[cursor].uid,
          showSuggestion: false,
        });
      }
    } else {
      result = [];
    }
  };
  renderShowSuggestion = () => {
    let suggestionArray = [];
    console.log(this.state.customer);
    if (this.state.customer) {
      console.log(this.state.customer);
      const suggestionById = this.props.allUsers.filter((user) =>
        user.userId.includes(this.state.customer)
      );
      const suggestionByName = this.props.allUsers.filter(
        (user) =>
          user.displayName &&
          user.displayName
            .toLowerCase()
            .includes(this.state.customer.toLowerCase())
      );
      suggestionArray = [...suggestionById, ...suggestionByName];
      const uniqueUser = [...new Set(suggestionArray)];
      console.log(suggestionArray);
      return uniqueUser.slice(0, 10).map((user, index) => (
        <li
          key={user.userId}
          style={{
            minWidth: "195px",
            backgroundColor: this.state.cursor == index ? "gainsboro" : "white",
          }}
          onClick={() =>
            this.setState({
              customer: `${user.userId}-${user.displayName}`,
              customerUid: user.uid,
              showSuggestion: false,
              subCategory: `${user.userId}-${user.displayName}`,
            })
          }
        >
          {user.userId}-{user.displayName ? user.displayName.slice(0, 13) : ""}
        </li>
      ));
    }
  };

  selectRow = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues: this.state.checkedValues.filter((item, j) => i !== item),
        selectAll: false,
      });
    } else {
      this.state.checkedValues.push(i);
      this.setState(
        {
          checkedValues: this.state.checkedValues,
        },
        () => {
          console.log(this.state.checkedValues);
        }
      );
    }
  };

  getParentCategory = (category, count) => {
    const { productObj } = this.state;
    if (productObj && productObj.id == category.id) {
      return null;
    }
    return (
      <>
        <option value={category.id}>{count + category.name}</option>

        {category.children &&
          category.children.length > 0 &&
          category.children.map((cat2) =>
            this.getParentCategory(cat2, count + "\u00A0 \u00A0")
          )}
      </>
    );
  };

  getCategories = (categories) => {
    const tree = categories.reduce((t, o) => {
      Object.assign((t[o.id] = t[o.id] || {}), o);

      // Check if `t[o.parentCategory]` is undefined or null, and initialize it if needed
      if (!t[o.parentCategory]) {
        t[o.parentCategory] = { children: [] };
      }

      // Ensure `children` array is initialized for `t[o.parentCategory]`
      if (!t[o.parentCategory].children) {
        t[o.parentCategory].children = [];
      }

      t[o.parentCategory].children.push(t[o.id]);

      return t;
    }, {});

    return tree[""].children;
  };

  render() {
    const { open, productObj } = this.state;
    const { categories, currentAdmin } = this.props;

    let allCategories = [];
    if (categories.length > 0) {
      allCategories = this.getCategories(categories);
      console.log(allCategories);
    }

    let renderableCategories = categories;
    if (this.state.searchFor) {
      renderableCategories = categories.filter((category) =>
        category.name.toLowerCase().includes(this.state.searchFor.toLowerCase())
      );
    }
    renderableCategories = renderableCategories.sort(
      (a, b) => a.name.charCodeAt(0) - b.name.charCodeAt(0)
    );

    console.log(this.props);
    return (
      <Fragment>
        {this.state.loader ? (
          <div
            style={{
              width: "100%",
              minWidth: "100%",
              height: "100%",
              minHeight: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "row",
              paddingTop: 400,
            }}
          >
            <ClipLoader loading={this.state.loader} size={30} color="#ec345b" />
          </div>
        ) : (
          <>
            <Breadcrumb title={"Categories"} parent="Products" />
            {/* <!-- Container-fluid starts--> */}
            <div className="container-fluid">
              <div className="row" style={{ justifyContent: "center" }}>
                <div className="col-sm-12">
                  <div className="card">
                    <div
                      className="card-header"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        borderBottom: "1px solid gainsboro",
                      }}
                    >
                      <div className="col">
                        <h5>
                          <i
                            className="icofont-layout"
                            style={{
                              fontSize: "130%",
                              marginRight: "5px",
                              color: "rgb(94, 166, 170)",
                            }}
                          ></i>
                          Categories
                        </h5>
                        <div>
                          <span
                            style={{ color: "#2271b1", cursor: "pointer" }}
                            onClick={() => {
                              this.props.history.push(
                                "/products/physical/categories-2/homescreen"
                              );
                            }}
                          >
                            Homescreen categories{" "}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-around",
                          marginTop: 5,
                        }}
                      >
                        {" "}
                        <li
                          style={{
                            border: "1px solid gainsboro",
                            borderRadius: "5rem",
                            padding: "0px 20px",
                            background: "whitesmoke",
                            marginRight: "20px",
                            marginBottom: "7px",
                          }}
                        >
                          <form
                            className="form-inline search-form"
                            onSubmit={this.handleSubmit}
                          >
                            <div
                              // className="form-group"
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-around",
                              }}
                            >
                              <input
                                className={
                                  "form-control-plaintext " +
                                  (this.state.searchbar ? "open" : "")
                                }
                                name="searchFor"
                                value={this.state.searchFor}
                                type="search"
                                placeholder="Search Category"
                                style={{ paddingLeft: 10 }}
                                onChange={this.handleSearchBarChange}
                              />
                              <span>
                                <Search
                                  style={{
                                    marginTop: "5px",
                                    borderLeft: "1px solid gainsboro",
                                    paddingLeft: "7px",
                                    color: "gray",
                                  }}
                                />
                              </span>
                            </div>
                          </form>
                        </li>
                        <li>
                          {" "}
                          <button
                            className="btn"
                            data-toggle="modal"
                            data-target="#personalInfoModal"
                            style={{
                              backgroundColor: "rgb(94, 166, 170)",
                              border: "none",
                              color: "white",
                              fontSize: 11,
                            }}
                            onClick={() => {
                              this.setState({
                                id: "",
                                name: "",
                                slug: "",
                                parentCategory: "",
                                productObj: null,
                                loading: false,
                                loading2: false,
                                imageUrl: man,
                                imageUrl2: man,
                                file: "",
                                checkedValues: [],
                                selectAll: false,
                                topCategory: false,
                                homePage: false,
                                type: "upload",
                              });
                            }}
                          >
                            Add New Category
                          </button>
                        </li>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="clearfix"></div>
                      <div id="basicScenario" className="product-physical">
                        {this.state.checkedValues.length > 0 ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              background: "#1A73E8",
                              width: "100%",
                              borderRadius: "5px",
                              justifyContent: "flex-start",
                              padding: 10,
                            }}
                          >
                            <div
                              style={{
                                alignSelf: "center",
                              }}
                            >
                              <i
                                className="icofont-close-line"
                                onClick={() => {
                                  this.setState({
                                    selectAll: false,
                                    checkedValues: [],
                                  });
                                }}
                                style={{
                                  color: "white",
                                  cursor: "pointer",
                                  fontSize: "25px",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                color: "white",
                                alignSelf: "center",
                                marginLeft: 20,
                              }}
                            >
                              {this.state.checkedValues.length} selected
                            </div>
                            <div
                              style={{
                                width: "1px",
                                height: "25px",
                                background: "white",
                                alignSelf: "center",
                                marginLeft: 40,
                              }}
                            ></div>
                            <div
                              style={{
                                color: "white",
                                alignSelf: "center",
                                marginLeft: 40,
                                padding: "5px 10px",
                                border: "1px solid white",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                              data-toggle="modal"
                              data-target="#deleteExpenseModal2"
                            >
                              Delete
                            </div>
                          </div>
                        ) : (
                          <div style={{ padding: 26.5 }}></div>
                        )}
                        <table className="table table-bordered table-striped table-hover">
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  padding: "30px 15px",
                                  color: "white",
                                  backgroundColor: "rgb(94, 166, 170)",
                                  minWidth: "150px",
                                  maxWidth: "150px",
                                }}
                              >
                                <div>
                                  <span
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      name={this.state.selectAll}
                                      checked={this.state.selectAll}
                                      onChange={(e) =>
                                        this.setState(
                                          {
                                            selectAll: !this.state.selectAll,
                                          },
                                          () => {
                                            if (this.state.selectAll) {
                                              this.setState(
                                                {
                                                  checkedValues: categories.map(
                                                    (category) => {
                                                      return category.id;
                                                    }
                                                  ),
                                                },
                                                () => {
                                                  console.log(
                                                    this.state.checkedValues
                                                  );
                                                }
                                              );
                                            } else {
                                              this.setState({
                                                checkedValues: [],
                                              });
                                            }
                                          }
                                        )
                                      }
                                      style={{
                                        height: 20,
                                        width: 20,
                                      }}
                                    />

                                    <div style={{ marginLeft: 5 }}>
                                      Select All
                                    </div>
                                  </span>
                                </div>
                              </th>
                              <th
                                scope="col"
                                style={{
                                  padding: "30px 15px",
                                  color: "white",
                                  backgroundColor: "rgb(94, 166, 170)",
                                  maxWidth: "150px",
                                  minWidth: "150px",
                                }}
                              >
                                Logo
                              </th>
                              <th
                                scope="col"
                                style={{
                                  padding: "30px 15px",
                                  color: "white",
                                  backgroundColor: "rgb(94, 166, 170)",
                                  maxWidth: "150px",
                                  minWidth: "150px",
                                }}
                              >
                                Name
                              </th>
                              <th
                                scope="col"
                                colSpan={2}
                                style={{
                                  padding: "30px 15px",
                                  color: "white",
                                  backgroundColor: "rgb(94, 166, 170)",
                                  maxWidth: "150px",
                                  minWidth: "150px",
                                }}
                              >
                                Slug
                              </th>
                              <th
                                scope="col"
                                style={{
                                  padding: "30px 15px",
                                  color: "white",
                                  backgroundColor: "rgb(94, 166, 170)",
                                }}
                              >
                                Parent Category
                              </th>
                              <th
                                scope="col"
                                style={{
                                  padding: "30px 15px",
                                  color: "white",
                                  backgroundColor: "rgb(94, 166, 170)",
                                }}
                              >
                                Homescreen Position
                              </th>
                              <th
                                scope="col"
                                style={{
                                  padding: "30px 15px",
                                  color: "white",
                                  backgroundColor: "rgb(94, 166, 170)",
                                }}
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {renderableCategories.map((category, index) => (
                              <tr key={index}>
                                <th scope="row">
                                  {" "}
                                  <div>
                                    <span
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        name={category.id}
                                        checked={this.state.checkedValues.includes(
                                          category.id
                                        )}
                                        style={{
                                          height: 20,
                                          width: 20,
                                        }}
                                        onChange={(e) =>
                                          this.selectRow(e, category.id)
                                        }
                                      />
                                    </span>
                                  </div>
                                </th>
                                <td>
                                  <a href={category.logo} target="_blank">
                                    <img
                                      style={{ height: 40, width: 40 }}
                                      src={category.logo || man}
                                    />
                                  </a>
                                </td>
                                <td>{category.name}</td>
                                <td colSpan={2}>{category.slug}</td>

                                <td>
                                  {categories.length > 0 &&
                                  categories.find(
                                    (cat1) => cat1.id == category.parentCategory
                                  )
                                    ? categories.find(
                                        (cat1) =>
                                          cat1.id == category.parentCategory
                                      ).name
                                    : ""}
                                </td>
                                <td>
                                  {category.homePosition
                                    ? category.homePosition
                                    : ""}
                                </td>
                                <td>
                                  <div
                                    className="row"
                                    style={{ justifyContent: "center" }}
                                  >
                                    <i
                                      className="icofont-edit"
                                      data-toggle="modal"
                                      data-target="#personalInfoModal"
                                      onClick={() => {
                                        this.setState({
                                          id: category.id,
                                          name: category.name,
                                          slug: category.slug,
                                          count: category.count,
                                          parentCategory:
                                            category.parentCategory,
                                          imageUrl: category.logo,
                                          imageUrl2: category.banner,
                                          type: "update",
                                          productObj: category,
                                          topCategory: category.topCategory,
                                          homePage: category.homePage,
                                          homePosition: category.homePosition
                                            ? category.homePosition
                                            : "",
                                          homePosition2: category.homePosition
                                            ? category.homePosition
                                            : "",
                                        });
                                      }}
                                      style={{
                                        color: "green",
                                        marginRight: 8,
                                        cursor: "pointer",
                                      }}
                                    />{" "}
                                    <i
                                      className="icofont-trash"
                                      data-toggle="modal"
                                      data-target="#deleteExpenseModal"
                                      onClick={() => {
                                        this.setState({
                                          productObj: category,
                                        });
                                      }}
                                      style={{
                                        color: "red",
                                        marginLeft: 8,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ToastContainer />
            {/* <!-- Container-fluid Ends--> */}
            <div
              className="modal fade"
              id="personalInfoModal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div
                className="modal-dialog"
                role="document"
                style={{ margin: "auto" }}
              >
                <div
                  className="modal-content"
                  style={{ top: 10, width: "95%", margin: "auto" }}
                >
                  <div
                    className="modal-header"
                    style={{
                      backgroundColor: "rgb(94, 166, 170)",
                      paddingTop: 20,
                      paddingBottom: 20,
                    }}
                  >
                    <div
                      className="modal-title"
                      style={{
                        fontWeight: "bold",
                        fontSize: 17,
                        color: "white",
                      }}
                      id="exampleModalLabel"
                    >
                      {productObj ? "Update" : "Add New"} Category <br />
                      Id:{productObj && productObj.id}
                    </div>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      id="personal-info-close"
                    >
                      <span aria-hidden="true" style={{ color: "white" }}>
                        &times;
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div style={{ padding: "10px 15px" }}>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={this.state.name}
                          onChange={this.handleChange}
                          id="exampleFormControlInput1"
                          placeholder="Enter category name"
                          style={{
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          Slug
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="slug"
                          value={this.state.slug}
                          onChange={this.handleChange}
                          id="exampleFormControlInput1"
                          placeholder="Enter slug name"
                          style={{
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          Parent Category
                        </label>
                        <select
                          title="Please choose a package"
                          required
                          name="parentCategory"
                          className="custom-select"
                          aria-required="true"
                          aria-invalid="false"
                          onChange={this.handleChange}
                          value={this.state.parentCategory}
                        >
                          <option value="">None</option>
                          {allCategories.map((category) =>
                            this.getParentCategory(category, "")
                          )}
                        </select>
                      </div>

                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          Category Logo
                        </label>
                        <div
                          className="box-input-file"
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          {this.state.loading ? (
                            <div
                              className="spinner-border text-light mt-3 ml-2"
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          ) : (
                            <>
                              <img
                                className="img-50 lazyloaded blur-up"
                                src={this.state.imageUrl}
                                alt="#"
                                style={{
                                  zIndex: 10,
                                  cursor: "pointer",
                                  border: "1px solid gainsboro",
                                  borderRadius: 5,
                                  minHeight: 50,
                                  maxHeight: 50,
                                }}
                                onClick={() => {
                                  document
                                    .getElementById("upload-image-input")
                                    .click();
                                }}
                              />

                              <input
                                id="upload-image-input"
                                className="upload"
                                type="file"
                                style={{
                                  position: "absolute",
                                  zIndex: 5,
                                  maxWidth: "50px",
                                  marginTop: "10px",
                                }}
                                onChange={(e) => this._handleImgChange(e, 0)}
                              />
                            </>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          Category Banner
                        </label>
                        <div
                          className="box-input-file"
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          {this.state.loading2 ? (
                            <div
                              className="spinner-border text-light mt-3 ml-2"
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          ) : (
                            <>
                              <img
                                className="img-50 lazyloaded blur-up"
                                src={this.state.imageUrl2}
                                alt="#"
                                style={{
                                  zIndex: 10,
                                  cursor: "pointer",
                                  border: "1px solid gainsboro",
                                  borderRadius: 5,
                                  minHeight: 50,
                                  maxHeight: 50,
                                }}
                                onClick={() => {
                                  document
                                    .getElementById("upload-image-input2")
                                    .click();
                                }}
                              />

                              <input
                                id="upload-image-input2"
                                className="upload"
                                type="file"
                                style={{
                                  position: "absolute",
                                  zIndex: 5,
                                  maxWidth: "50px",
                                  marginTop: "10px",
                                }}
                                onChange={(e) => this._handleImgChange2(e, 0)}
                              />
                            </>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <span
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <input
                            type="checkbox"
                            name={this.state.topCategory}
                            checked={this.state.topCategory}
                            onChange={(e) =>
                              this.setState({
                                topCategory: !this.state.topCategory,
                              })
                            }
                            style={{
                              height: 20,
                              width: 20,
                            }}
                          />

                          <div
                            style={{
                              marginLeft: 5,
                              fontWeight: "bold",
                              color: "#505050",
                              marginBottom: 5,
                            }}
                          >
                            Top Category
                          </div>
                        </span>
                      </div>
                      <div className="form-group">
                        <span
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <input
                            type="checkbox"
                            name={this.state.homePage}
                            checked={this.state.homePage}
                            onChange={(e) =>
                              this.setState({
                                homePage: !this.state.homePage,
                              })
                            }
                            style={{
                              height: 20,
                              width: 20,
                            }}
                          />

                          <div
                            style={{
                              marginLeft: 5,
                              fontWeight: "bold",
                              color: "#505050",
                              marginBottom: 5,
                            }}
                          >
                            Show on Homescreen
                          </div>
                        </span>
                      </div>
                      {this.state.homePage && (
                        <div className="form-group">
                          <label
                            style={{
                              fontWeight: "bold",
                              color: "#505050",
                              marginBottom: 5,
                            }}
                          >
                            Homescreen position
                          </label>
                          <select
                            title="Please choose a package"
                            required
                            name="homePosition"
                            className="custom-select"
                            aria-required="true"
                            aria-invalid="false"
                            onChange={this.handleChange}
                            value={this.state.homePosition}
                          >
                            <option value="">None</option>
                            {this.props.homeCategories.map(
                              (category, index) => (
                                <option value={index + 1}>{index + 1}</option>
                              )
                            )}
                            {this.state.type == "upload" ? (
                              <option
                                value={this.props.homeCategories.length + 1}
                              >
                                {this.props.homeCategories.length + 1}
                              </option>
                            ) : this.state.type == "update" &&
                              this.state.homePosition2 == "" ? (
                              <option
                                value={this.props.homeCategories.length + 1}
                              >
                                {this.props.homeCategories.length + 1}
                              </option>
                            ) : (
                              ""
                            )}
                          </select>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn "
                      data-dismiss="modal"
                      style={{
                        backgroundColor: "darkorange",
                        color: "white",
                        padding: 8,
                        borderRadius: 5,
                        fontWeight: "lighter",
                      }}
                      onClick={() => {
                        this.handleSubmit();
                      }}
                    >
                      {productObj ? "UPDATE" : "ADD"} Category
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="InvoiceInfoModal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div
                className="modal-dialog"
                role="document"
                style={{ margin: "auto" }}
              >
                <div
                  className="modal-content"
                  style={{ top: 10, width: "95%", margin: "auto" }}
                >
                  <div
                    className="modal-header"
                    style={{
                      backgroundColor: "rgb(94, 166, 170)",
                      paddingTop: 20,
                      paddingBottom: 20,
                    }}
                  >
                    <div
                      className="modal-title"
                      style={{
                        fontWeight: "bold",
                        fontSize: 17,
                        color: "white",
                      }}
                      id="exampleModalLabel"
                    >
                      Sell
                    </div>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      id="personal-info-close"
                    >
                      <span aria-hidden="true" style={{ color: "white" }}>
                        &times;
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div style={{ padding: "10px 15px" }}>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          SELECT CUSTOMER
                        </label>
                        <input
                          title="Please choose a package"
                          style={{ padding: 18 }}
                          type="text"
                          name="customer"
                          className="form-control"
                          placeholder="Enter customer Id"
                          aria-required="true"
                          aria-invalid="false"
                          onChange={this.handleChangeCustomer}
                          value={this.state.customer}
                          required
                          autoComplete="off"
                          onKeyDown={this.handleKeyDown}
                        />
                        {this.state.customer && (
                          <ul
                            className="below-searchbar-recommendation"
                            style={{
                              display: this.state.showSuggestion
                                ? "flex"
                                : "none",
                              zIndex: 11,
                            }}
                          >
                            {this.renderShowSuggestion()}
                          </ul>
                        )}
                      </div>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          PRODUCT IMAGE
                        </label>
                        <div
                          className="box-input-file"
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          <>
                            <img
                              className="img-100 lazyloaded blur-up"
                              src={this.state.imageUrl}
                              alt="#"
                              style={{
                                zIndex: 10,
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                document
                                  .getElementById("upload-image-input")
                                  .click();
                              }}
                            />
                          </>
                        </div>
                      </div>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          PRODUCT NAME
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={this.state.name}
                          onChange={this.handleChange}
                          id="exampleFormControlInput1"
                          placeholder="Product Name"
                          style={{
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          DESCRIPTION
                        </label>
                        <textarea
                          type="text"
                          className="form-control"
                          name="description"
                          value={this.state.description}
                          onChange={this.handleChange}
                          id="exampleFormControlInput1"
                          placeholder="Ex: size, color, other details etc"
                          style={{
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          QUANTITY
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="quantity"
                          onChange={this.handleChange}
                          value={this.state.quantity}
                          id="exampleFormControlInput1"
                          placeholder="Enter Product Quantity"
                          style={{
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          PRICE/QUANTITY
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="amount"
                          onChange={this.handleChange}
                          value={this.state.amount}
                          id="exampleFormControlInput1"
                          placeholder="Enter Amount"
                          style={{
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn "
                      data-dismiss="modal"
                      style={{
                        backgroundColor: "darkorange",
                        color: "white",
                        padding: 8,
                        borderRadius: 5,
                        fontWeight: "lighter",
                      }}
                      onClick={() => {
                        this.handleGenerateNow();
                      }}
                    >
                      Generate
                    </button>
                    <button
                      type="button"
                      className="btn "
                      data-dismiss="modal"
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        padding: 8,
                        borderRadius: 5,
                        fontWeight: "lighter",
                      }}
                      onClick={() => {
                        this.handlePayNow();
                      }}
                    >
                      Pay Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="deleteExpenseModal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div
                className="modal-dialog"
                role="document"
                style={{ margin: "auto" }}
              >
                <div
                  className="modal-content"
                  style={{ top: 10, margin: "auto", minWidth: "140%" }}
                >
                  <div
                    className="modal-header"
                    style={{
                      backgroundColor: "rgb(94, 166, 170)",
                      paddingTop: 20,
                      paddingBottom: 20,
                    }}
                  >
                    <div
                      className="modal-title"
                      style={{
                        fontWeight: "bold",
                        fontSize: 17,
                        color: "white",
                      }}
                      id="exampleModalLabel"
                    >
                      Delete Category
                    </div>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      id="personal-info-close"
                    >
                      <span aria-hidden="true" style={{ color: "white" }}>
                        &times;
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div style={{ padding: "10px 15px" }}>
                      <div>Are you sure you want to delete this Category?</div>
                    </div>
                    <table className="table table-bordered table-striped table-hover">
                      <thead>
                        <tr></tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {productObj && (
                              <img
                                style={{ height: 70, width: 70 }}
                                src={productObj.logo}
                              />
                            )}
                          </td>
                          <td>{productObj && productObj.name}</td>
                          <td>{productObj && productObj.slug}</td>
                          <td>{productObj && productObj.count}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className="btn "
                      data-dismiss="modal"
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        padding: 8,
                        borderRadius: 5,
                      }}
                      onClick={async () => {
                        this.props.deleteCategoryRedux(
                          productObj,
                          productObj.parentCategory
                        );
                        if (productObj.logo) {
                          await deleteImage(productObj.logo);
                        }
                        if (productObj.banner) {
                          await deleteImage(productObj.banner);
                        }
                        this.setState({
                          selectAll: false,
                          checkedValues: [],
                        });
                      }}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="deleteExpenseModal2"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div
                className="modal-dialog"
                role="document"
                style={{ margin: "auto" }}
              >
                <div
                  className="modal-content"
                  style={{ top: 10, margin: "auto", minWidth: "140%" }}
                >
                  <div
                    className="modal-header"
                    style={{
                      backgroundColor: "rgb(94, 166, 170)",
                      paddingTop: 20,
                      paddingBottom: 20,
                    }}
                  >
                    <div
                      className="modal-title"
                      style={{
                        fontWeight: "bold",
                        fontSize: 17,
                        color: "white",
                      }}
                      id="exampleModalLabel"
                    >
                      Delete All Selected Categories
                    </div>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      id="personal-info-close"
                    >
                      <span aria-hidden="true" style={{ color: "white" }}>
                        &times;
                      </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div style={{ padding: "10px 15px" }}>
                      <div>
                        Are you sure you want to delete{" "}
                        {this.state.checkedValues.length} Categories?
                      </div>
                    </div>
                    <table className="table table-bordered table-striped table-hover">
                      <thead>
                        <tr></tr>
                      </thead>
                    </table>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className="btn "
                      data-dismiss="modal"
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        padding: 8,
                        borderRadius: 5,
                      }}
                      onClick={async () => {
                        this.state.checkedValues.map(async (id) => {
                          let category = categories.find(
                            (cat1) => cat1.id == id
                          );
                          await this.props.deleteCategoryRedux(
                            category,
                            category.parentCategory
                          );
                          if (category.logo) {
                            deleteImage(category.logo);
                          }
                          if (category.banner) {
                            deleteImage(category.banner);
                          }
                        });
                        this.setState({
                          selectAll: false,
                          checkedValues: [],
                        });
                      }}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allUsers: state.users.users,
    currentAdmin: state.admins.currentAdmin,
    categories: state.categories.categories,
    homeCategories: state.categories.homeCategories,
  };
};

export default connect(mapStateToProps, {
  getAllCategoriesRedux,
  uploadCategoryRedux,
  updateCategoryRedux,
  deleteCategoryRedux,
  getAllHomeScreenCategoriesRedux,
})(Categories);
